var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Input, Renderer } from '@angular/core';
export var ErrorSrcDirective = (function () {
    function ErrorSrcDirective(el, renderer) {
        this.EVENT_TYPE = 'error';
        this.isApplied = false;
        this.el = el.nativeElement;
        this.el.addEventListener(this.EVENT_TYPE, this.onError.bind(this));
    }
    ErrorSrcDirective.prototype.onError = function () {
        this.removeEvents();
        if (!this.isApplied) {
            this.isApplied = true;
            this.el.setAttribute('src', this.errorSrc);
        }
    };
    ErrorSrcDirective.prototype.removeEvents = function () {
        this.el.removeEventListener(this.EVENT_TYPE, this.onError);
    };
    ErrorSrcDirective.prototype.ngOnDestroy = function () {
        this.removeEvents();
    };
    __decorate([
        Input('error-src'), 
        __metadata('design:type', String)
    ], ErrorSrcDirective.prototype, "errorSrc", void 0);
    ErrorSrcDirective = __decorate([
        Directive({ selector: '[error-src]' }), 
        __metadata('design:paramtypes', [ElementRef, Renderer])
    ], ErrorSrcDirective);
    return ErrorSrcDirective;
}());
